import React, { FC, useState } from 'react';

import SearchStore from 'src/search/store/SearchStore';
import useAfterRenderCallback from 'src/common/hooks/useAfterRenderCallback';
import ActiveFilters from '../ActiveFilters';
import FilterButton from '../FilterButton';
import FiltersModal from '../FiltersModal';
import styles from './Filters.module.scss';

type FiltersProps = {
  searchStore: SearchStore;
};

const Filters: FC<FiltersProps> = ({ searchStore }) => {
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const onFilterButtonClick = useAfterRenderCallback(() => {
    if (!filterModalOpen) setFilterModalOpen(true);
  });

  const onFilterModalClose = useAfterRenderCallback(() => {
    if (filterModalOpen) {
      setFilterModalOpen(false);
    }
  });

  return (
    <div className={styles.root}>
      <FiltersModal
        searchStore={searchStore}
        isOpen={filterModalOpen}
        onModalClose={onFilterModalClose}
      />
      <FilterButton
        activeFiltersCount={searchStore.activeFiltersCount}
        onClick={onFilterButtonClick}
      />
      <ActiveFilters store={searchStore} />
    </div>
  );
};

export default Filters;
